// Hit or miss of one KPI in one period, for the weekly grid (KPI Beast grid study): the
// metric's direction applied to the trend point's actual and target. No actual or no target
// is "none" (grey), never a miss: missing data is never red.
import type { ScoreMarkState } from "@companyos/ui";
import type { ScorecardMetric } from "../api/types";

export function hitMiss(
  direction: ScorecardMetric["direction"],
  actual: number | null,
  target: number | null,
  targetMax: number | null = null,
): ScoreMarkState {
  if (actual === null || target === null) return "none";
  switch (direction) {
    case "gte":
      return actual >= target ? "hit" : "miss";
    case "gt":
      return actual > target ? "hit" : "miss";
    case "lte":
      return actual <= target ? "hit" : "miss";
    case "lt":
      return actual < target ? "hit" : "miss";
    case "eq":
      return actual === target ? "hit" : "miss";
    case "between":
      return actual >= target && actual <= (targetMax ?? target) ? "hit" : "miss";
  }
}

/** The grid's rows: KPI metrics only (scored, with weight), in scorecard order. */
export function kpiMetrics(metrics: readonly ScorecardMetric[]): ScorecardMetric[] {
  return metrics.filter((m) => m.tracking_mode === "scored" && m.kpi_weight > 0);
}
